var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDoneOutline = function SvgDoneOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.586l-5.293-5.293a1 1 0 00-1.414 1.414l6 6a1 1 0 001.414 0l12-12a1 1 0 00-1.414-1.414L11 18.586z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDE4LjU4NThMNS43MDcxMSAxMy4yOTI5QzUuMzE2NTggMTIuOTAyNCA0LjY4MzQyIDEyLjkwMjQgNC4yOTI4OSAxMy4yOTI5QzMuOTAyMzcgMTMuNjgzNCAzLjkwMjM3IDE0LjMxNjYgNC4yOTI4OSAxNC43MDcxTDEwLjI5MjkgMjAuNzA3MUMxMC42ODM0IDIxLjA5NzYgMTEuMzE2NiAyMS4wOTc2IDExLjcwNzEgMjAuNzA3MUwyMy43MDcxIDguNzA3MTFDMjQuMDk3NiA4LjMxNjU4IDI0LjA5NzYgNy42ODM0MiAyMy43MDcxIDcuMjkyODlDMjMuMzE2NiA2LjkwMjM3IDIyLjY4MzQgNi45MDIzNyAyMi4yOTI5IDcuMjkyODlMMTEgMTguNTg1OFoiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==";
export { SvgDoneOutline as ReactComponent };